import { Routes, Route, useNavigate, Navigate } from "react-router-dom";
import "./App.css";
// -----------Routes------------------
import CommonRoutes from "Routes/Routes";
import ScrollToTop from "Utils/ScrollToTop";
import { addResponseInterceptor } from "Services/config";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";

import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
export default function App() {
    const navigator = useNavigate();
    //Setup response interceptor with navigation function
    addResponseInterceptor(navigator);
    return (
        <>
            <ToastContainer />

            <ScrollToTop />
            <Routes>
                <Route path="/*" element={<CommonRoutes />} />
            </Routes>
        </>
    );
}
